@use '../../styling/colors.scss' as *;
@use '../../styling/typography.scss' as *;

.Chip {
  @extend %font-family-primary;

  box-sizing: border-box;
  display: inline-block;
  padding: 2px 6px;
  font-weight: $font-weight-semibold;
  color: $theme-color-text;
  border: 1px solid $theme-color-borders;
  border-radius: 4px;
  font-size: $font-size-normal;

  &.noWrap {
    width: max-content;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &.withoutBorder {
    border: 0;
  }
}
